// Catalog of report definitions for the Reportes page directory. Every entry
// maps to a real, working report — "Ejecutar" generates a printable/PDF
// version (see ReportPrintView.js) using the same backend endpoints and
// data shown live in the other Reportes tabs, not a separate report engine.
// `dateRange: false` marks reports where a from/to filter wouldn't change
// anything (e.g. a live snapshot like current AR aging).
// `customerSpecific: true` marks reports that need a client picked in the
// modal (in addition to a date range, unless dateRange is also false).
const REPORTS_CATALOG = [
  {
    category: 'Ventas',
    reports: [
      { id: 'sales-detail', name: 'Ventas detalladas (facturas y formas de pago)' },
      { id: 'sales-by-customer', name: 'Ventas por Cliente' },
      { id: 'sales-by-product', name: 'Ventas por Producto' },
      { id: 'new-customers', name: 'Clientes Nuevos' },
      { id: 'inactive-customers', name: 'Clientes Inactivos', dateRange: false },
    ],
  },
  {
    category: 'Cuentas por Cobrar',
    reports: [
      { id: 'ar-aging', name: 'Antigüedad de Cuentas por Cobrar (Aging)', dateRange: false },
      { id: 'customer-statement', name: 'Estado de Cuenta por Cliente', customerSpecific: true },
      { id: 'outstanding-invoices', name: 'Facturas Pendientes', dateRange: false },
      { id: 'payment-register', name: 'Registro de Pagos' },
      { id: 'receipts-by-client', name: 'Recibos de Ingreso por Cliente', clientOptional: true },
      { id: 'collections', name: 'Cobros (Día/Mes)' },
      { id: 'dso', name: 'Días Promedio de Pago (DSO)' },
    ],
  },
  {
    category: 'Cotizaciones',
    reports: [
      { id: 'quotes-by-status', name: 'Cotizaciones por Estado' },
    ],
  },
  {
    category: 'Conduces',
    reports: [
      // clientOptional: the client picker narrows the report but isn't required, unlike customerSpecific
      // reports (e.g. customer-statement) which need one. statusFilter: adds the Entregados/Todos toggle.
      { id: 'conduces', name: 'Conduces por Cliente', clientOptional: true, statusFilter: true },
    ],
  },
  {
    category: 'Gastos y Rentabilidad',
    reports: [
      { id: 'expenses-summary', name: 'Resumen de Gastos' },
      { id: 'expenses-by-category', name: 'Gastos por Categoría' },
      { id: 'product-margin', name: 'Margen Bruto por Producto' },
      { id: 'profit-and-loss', name: 'Estado de Resultados (P&L simplificado)' },
    ],
  },
  {
    category: 'DGII',
    reports: [
      // tipoFilter: adds the tipo de comprobante picker (all, or one of E31–E34)
      { id: 'ncf-listing', name: 'Listado de Facturas con NCF', tipoFilter: true },
      { id: 'dgii-607', name: '607 — Ventas' },
      { id: 'dgii-608', name: '608 — Comprobantes Anulados' },
      { id: 'itbis-summary', name: 'Resumen de ITBIS' },
    ],
  },
  {
    category: 'KPIs de Negocio',
    reports: [
      { id: 'repeat-client-rate', name: 'Tasa de Clientes Recurrentes' },
      { id: 'revenue-concentration', name: 'Concentración de Ingresos (Top Clientes)' },
      { id: 'reorder-cycle', name: 'Ciclo Promedio de Recompra', dateRange: false },
      { id: 'itbis-payable', name: 'ITBIS a Pagar (próximo período)' },
      { id: 'avg-invoice-value', name: 'Ingreso Promedio por Factura' },
    ],
  },
];

// Default dateRange to true unless explicitly set false above.
REPORTS_CATALOG.forEach(group => {
  group.reports.forEach(r => {
    if (r.dateRange === undefined) r.dateRange = true;
  });
});

export default REPORTS_CATALOG;
